import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormControlName, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { TextMaskModule } from "src/app/directives/angular2TextMask";
import { Toast } from "src/app/ui/components/toast/toast";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { BeneficaryTemporaryLimit, Beneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/beneficiary";
import { Dependent } from "src/app/ui/models/domains/pbm/Beneficiary/dependent";
import { LoadingService } from "src/app/ui/services/loading.service";
import { BeneficiaryService } from "src/app/ui/services/pbm/beneficiary.service";

@Component({
  selector: "limit-beneficiary-modal",
  templateUrl: "./limit-beneficiary-modal.component.html",
  styleUrls: ["./limit-beneficiary-modal.component.scss"],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule],
})
export class LimitBeneficiaryModalComponent implements OnInit {
  beneficiary: Beneficiary | Dependent;
  limitConfiguration: BeneficaryTemporaryLimit;

  form = new FormGroup({
    newLimitInput: new FormControl(0),
  });

  constructor(
    private dialogRef: MatDialogRef<LimitBeneficiaryModalComponent>,
    private toast: Toast,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private beneficiaryService: BeneficiaryService,
    private loadingService: LoadingService,
  ) {
    if (data) {
      this.beneficiary = data.beneficiary ?? data.dependent;
      this.form.get("newLimitInput").setValue(this.beneficiary.getLimit());
    }
  }

  ngOnInit() {}

  close() {
    this.toast.showWarningToast("As alterações não foram salvas");
    this.dialogRef.close(false);
  }

  async saveNewtemporaryLimit() {
    const ref = this.loadingService.beginLoading();
    try {
      this.limitConfiguration = new BeneficaryTemporaryLimit();
      this.limitConfiguration.beneficiaryId = this.beneficiary.getBeneficiaryKey().getValue();
      this.limitConfiguration.newLimit = this.form.get("newLimitInput").value;
      await this.beneficiaryService.beneficiaryTemporaryLimit(this.limitConfiguration);
      this.toast.showSuccessToast("Limite alterado com sucesso");
      this.dialogRef.close(true);
    } catch (error) {
      const errorMessage = error.error.Data?.ErrorMessage;
      if (!errorMessage) {
        this.toast.showWarningToast("Erro ao alterar o limite");
      } else {
        this.toast.showWarningToast(errorMessage);
      }
      console.error(error);
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  inputValidator(event): void {
    const input = event.target;
    const oldValue = input.value;
    const regex = new RegExp(input.pattern, "g");

    setTimeout(() => {
      const newValue = input.value;
      if (!regex.test(newValue)) {
        input.value = oldValue;
      }
    }, 0);
  }

}
